import { AutoshipBadge } from 'components/badges/autoship/AutoshipBadge';
import { FormattedUnitValue } from 'components/text';
import { FeatureIconName, Icons } from 'libs/icons';
import { useTranslation } from 'libs/translations';
import { useState } from 'react';
import { IUserPersonalAutoshipsData, IUserProfile } from 'types';

import { Widget } from '../Widget';
import { AutoshipModal, IAutoshipDetails } from './AutoshipModal';

interface IWidgetOwnAutoshipsProps extends IUserPersonalAutoshipsData {
  readonly userProfile: IUserProfile;
}

export function WidgetOwnAutoships({
  autoshipsPersonalList,
  userProfile
}: IWidgetOwnAutoshipsProps) {
  const { t } = useTranslation();
  const [autoshipDetails, setAutoshipDetails] = useState<IAutoshipDetails>();

  const sortedAutoships = [...autoshipsPersonalList].sort(a =>
    a.status === 'processed' ? -1 : 1
  );

  return (
    <Widget
      traceId="Personal Autoships"
      title={t('Personal Autoships')}
      iconName={FeatureIconName.Autoships}
      content={
        <div className="flex flex-wrap gap-x-md gap-y-xs">
          {sortedAutoships.map((autoship, index) => (
            <button
              title={undefined}
              type="button"
              key={`autoship_${index}`}
              className="space-x-xs flex items-center"
              onClick={() =>
                setAutoshipDetails({
                  ...autoship,
                  owner: userProfile
                })
              }
            >
              <FormattedUnitValue unit="points" value={autoship.points} />
              <AutoshipBadge
                status={autoship.status}
                style="date"
                lastExecutionDate={autoship?.lastExecutionDate}
                nextExecutionDate={autoship?.nextExecutionDate}
              />
            </button>
          ))}
          {autoshipsPersonalList.length === 0 && (
            <Icons.Common.Cancel size={20} className="text-error" />
          )}
          {autoshipDetails && (
            <AutoshipModal
              {...autoshipDetails}
              loadAutoshipDetails={true}
              onDismiss={() => setAutoshipDetails(undefined)}
            />
          )}
        </div>
      }
    />
  );
}
